export default __webpack_public_path__ + "static/solidified-remains-480-b07b6aa3488ad533cdae5cf756b17207.mp4";